import { render, staticRenderFns } from "./ClientRequiresPO.vue?vue&type=template&id=07686224&"
import script from "./ClientRequiresPO.vue?vue&type=script&lang=js&"
export * from "./ClientRequiresPO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports